import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, Gift, Upload, Settings, LogOut, LayoutGrid, BookMarked } from 'lucide-react';

const AdminNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin/panel', label: 'Dashboard', icon: Home },
    { path: '/admin/rewards/bulk-upload', label: 'Bulk Upload', icon: Upload },
    { path: '/admin/rewards/manage', label: 'Manage Rewards', icon: LayoutGrid },
    { path: '/admin/purchases', label: 'Purchases', icon: Gift },
    { path: '/admin/standards', label: 'Standards', icon: BookMarked },
    { path: '/admin/rewards', label: 'Reward Settings', icon: Settings },
  ];

  return (
    <div className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo/Title */}
          <div className="flex items-center gap-2">
            <Gift className="w-6 h-6 text-blue-600" />
            <span className="text-xl font-bold text-slate-900">Admin Panel</span>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center gap-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Button
                  key={item.path}
                  variant={isActive ? 'default' : 'ghost'}
                  onClick={() => navigate(item.path)}
                  className={`flex items-center gap-2 ${
                    isActive ? 'bg-blue-600 text-white' : 'text-slate-600 hover:text-slate-900'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="hidden sm:inline">{item.label}</span>
                </Button>
              );
            })}

            {/* Logout Button */}
            <Button
              variant="ghost"
              onClick={handleLogout}
              className="flex items-center gap-2 text-red-600 hover:text-red-700 hover:bg-red-50"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden sm:inline">Logout</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminNav;
